import type { Template } from "@/types";

export const SQ_02_H1_V1: Template[] = [
    {
        id: "sq-02-h1v1-01",
        name: "SQ 01 - H1V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-02-h1_v1_01.png",    
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 59, y: 159, width: 600, height: 400, rotation: 0, imageRotation: 0 },
            { id: "2", x: 943, y: 159, width: 266, height: 400, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-02-h1v1-02",
        name: "SQ 02 - H1V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-02-h1_v1_02.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 58, y: 59, width: 907, height: 599, rotation: 0, imageRotation: 0 },
            { id: "2", x: 973, y: 59, width: 403, height: 600, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "sq-02-h1v1-03",
        name: "SQ 03 - H1V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-02-h1_v1_03.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 127, y: 91, width: 811, height: 536, rotation: 0, imageRotation: 0 },
            { id: "2", x: 946, y: 91, width: 360, height: 536, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "sq-02-h1v1-04",
        name: "SQ 04 - H1V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-02-h1_v1_04.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 160, y: 228, width: 397, height: 263, rotation: 0, imageRotation: 0 },
            { id: "2", x: 875, y: 60, width: 402, height: 599, rotation: 0, imageRotation: 0 }
        ],
    },


    {
        id: "sq-02-h1v1-05",
        name: "SQ 05 - H1V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-02-h1_v1_05.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 60, y: 159, width: 598, height: 401, rotation: 0, imageRotation: 0 },
            { id: "2", x: 974, y: 60, width: 402, height: 599, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-02-h1v1-06",
        name: "SQ 06 - H1V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-02-h1_v1_06.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 0, y: 0, width: 1037, height: 717, rotation: 0, imageRotation: 0 },
            { id: "2", x: 1097, y: 155, width: 274, height: 408, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-02-h1v1-07",
        name: "SQ 07 - H1V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-02-h1_v1_07.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 0, y: 111, width: 717, height: 495, rotation: 0, imageRotation: 0 },
            { id: "2", x: 846, y: 0, width: 460, height: 717, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-02-h1v1-08",
        name: "SQ 08 - H1V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-02-h1_v1_08.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 58, y: 52, width: 873, height: 615, rotation: 0, imageRotation: 0 },
            { id: "2", x: 939, y: 52, width: 443, height: 615, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "sq-02-h1v1-09",
        name: "SQ 09 - H1V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-02-h1_v1_09.png",
        size: [1434, 717],
        style: {},
        slots: [      
            { id: "1", x: 63, y: 155, width: 274, height: 408, rotation: 0, imageRotation: 0 },
            { id: "2", x: 402, y: 0, width: 1037, height: 717, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "sq-02-h1v1-10",
        name: "SQ 10 - H1V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-02-h1_v1_10.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 209, y: 135, width: 300, height: 450, rotation: 0, imageRotation: 0 },
            { id: "2", x: 760, y: 135, width: 630, height: 450, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "sq-02-h1v1-11",
        name: "SQ 11 - H1V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-02-h1_v1_11.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 717, y: 120, width: 717, height: 478, rotation: 0, imageRotation: 0 },
            { id: "2", x: 120, y: 0, width: 478, height: 717, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-02-h1v1-12",
        name: "SQ 12 - H1V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-02-h1_v1_12.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 195, y: 121, width: 319, height: 478, rotation: 0, imageRotation: 0 },
            { id: "2", x: 522, y: 121, width: 720, height: 478, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "sq-02-h1v1-13",
        name: "SQ 13 - H1V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-02-h1_v1_13.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 163, y: 70, width: 390, height: 580, rotation: 0, imageRotation: 0 },
            { id: "2", x: 824, y: 192, width: 505, height: 337, rotation: 0, imageRotation: 0 },
        ],
    },

];


